<template>
  <div class="dialogue-tool">
    <Poptip v-model="visible" :width="350" word-wrap placement="top-start" @on-popper-show="getDialogue">
        <Icon type="ios-text-outline" />
        <div class="api" slot="content">
            <List size="small">
              <Scroll :distance-to-edge="-20" :on-reach-bottom="getDialogueMore">
                <ListItem style="display: block;" v-for="(item, index) in dialogueData.data" :key="index">
                  <p><span style="color: #999">{{item.cate.name}}</span> - {{item.questions}}</p>
                  <p v-if="item.answers_short.formatText" @click="emitDialogue(item.answers_short)" class="text-clamped">{{item.answers_short.formatText}}</p>
                </ListItem>
              </Scroll>
              <div class="api" slot="header">
                <Input @on-change="searchDialogue()" v-model="keyword" placeholder="搜索" style="width: 300px" />
              </div>
            </List>
        </div>
    </Poptip>
  </div>
</template>
<script>
import conf from "../../conf";
import RequestUtils from "@/utils/RequestUtils";


export default {
  name: "faces",
  components: {},
  data() {
    return {
      dialogueData: {},
      keyword: '',
      tempList: [],
      visible: false
    };
  },
  methods: {
    // 加载快捷知识
    getDialogue (page) {
      let param = new FormData();
      page = page || 1
      param.set("fetch", 'all');
      param.set("page", page);
      param.set("keyword", this.keyword);

      RequestUtils.request(conf.getKnowQa(), param).then(json => {
        if (page == 1) {
          this.dialogueData = json;
        } else {
          for (var i=0; i<json.data.length; i++) {
            this.dialogueData.data.push(json.data[i]);
            this.dialogueData.current_page = json.current_page;
            this.dialogueData.last_page = json.last_page;
          }
        }
      })
    },
    // 加载更多
    getDialogueMore() {
      return new Promise(resolve => {
        if (this.dialogueData.current_page < this.dialogueData.last_page) {        
          this.getDialogue(this.dialogueData.current_page+1);
        }
        resolve();
      });      
    },
    emitDialogue (data) {
      this.$emit('updatemessagecon', data.text);
      if (data.images.length > 0) {
        for (var i=0; i<data.images.length; i++) {
          console.log(data.images[i])
          this.$emit('uploadback', data.images[i]);
        }
      }
      this.visible = false;
    },
    // 搜索快捷短语
    searchDialogue () {
      if (this.keyword) {
         this.getDialogue()
      }
    }
  }
};
</script>

<style scoped lang="scss">

.dialogue-tool {
  display: inline-block;

  .ivu-poptip-popper {
    width: 300px!important;
    max-width: 300px!important;
    word-wrap: break-word;
  }
}
.ivu-poptip-popper {
  width: 300px!important;
  max-width: 300px!important;
  word-wrap: break-word;
}
.text-clamped {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  line-height: 16px;
  max-height: 48px;
  overflow-y: hidden;
  text-overflow: ellipsis;
  word-wrap: break-word;
  text-align: left;
  font-family: HelveticaNeue;
  font-size: 13px;
  letter-spacing: 0;
  cursor: pointer;text-align: left;
  font-family: HelveticaNeue;
  font-size: 13px;
  letter-spacing: 0;
  cursor: pointer;
}
</style>
